module.exports = __webpack_public_path__ + "static/img/h2-17.cdb9660.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd102/h2-17.png
// module id = B+ao
// module chunks = 1